import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-faultreport',
  templateUrl: './faultreport.component.html',
  styleUrls: ['./faultreport.component.sass']
})
export class FaultreportComponent implements OnInit {
  public banlist: any;
  public selectBan;
  public terminos;
  public subscribers = [];
  public screen = 2;
  public textoMovil = false;
  public accountList = sessionStorage.AccountList;
  public tabActive = 'Mis Servicios';
  public offer;
  public expand = [];
  public sw1 = true;
  public sw2 = false;
  public viewNetflixTerminos = false;
  public viewNetflixPeperless = false;
  public isChecked = false;
  public paperlessCheck = false;
  public accountSel = "";
  public subscriberSel = "";
  public inicio = true;
  public subscriberCounter = 0;
  public paperless;
  public accountList2;
  public index;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public cuentas;
  public type;
  public totalAccountList;
  public subscribernumber;
  public accounInfo;
  public screenView = [];
  public token: string = sessionStorage.getItem("token");
  public typeOfBreakdown = "";
  public accountType;
  public typeOfFault = "";
  public nroContrato1 = "";
  public detalle = "";
  public accountSubtype;
  public nroContrato2 = "";
  public respuesta = [];
  public ticketExists;
  loadObserver: Subscription;
  constructor(public AngularFireAnalytics:AngularFireAnalytics, private router: Router, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global: GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Reporte de Averías");
    this.AngularFireAnalytics.logEvent("Reporte de Averías-Screenview");
   }
  ngOnInit() {
    this.global.validateSession();
    if (this.global.sessionReview() == true) {
      this.banlist = JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan = atob(sessionStorage.getItem("selectBan"));
      this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
      this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
      this.subscribernumber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.subscriberNumberField;
      this.accountType = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountTypeField;
      this.accountSubtype = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountSubtypeField;
      this.global.mask(this.subscribernumber);
      this.expand[0] = true;
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value);
      });
      for (let i = 0; i < this.subscribers.length; i++) {
        this.screenView[i] = 1;
      }
    }
  }

  refreshDataTo(event: Event) {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }

  initializeData() {
    this.global.refreshDataTo(this.token);
  }

  dataLoading(sw) {
    this.loadingScreenService.stopLoading();
    if (this.postpago == true) {
      this.type = "postpaid";
    }
    else if (this.prepago == true) {
      this.type = "prepaid";
    }
    else if (this.telefoniaFijo == true) {
      this.type = "fixed";
    }
    this.subscribers = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.accounInfo = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo;
  }

  updateExpand(index) {
    if (this.global.validateSession() === true) {
      this.expand[index] = !this.expand[index];
    }
  }

  ngOnDestroy() {
    this.loadObserver.unsubscribe();
  }
}